import { Market } from "../../config/site/types";

// @ts-ignore
export const onlyLetters = /\p{L}+/u;
export const notOnlyWhitespace = /^(?!\s*$).+/;
export const onlyNumbers = /^[0-9]*$/;
export const countryCode = /^\+\d{1,3}$/;
export const JPdateRegex = /^(?:0[1-9]|1[0-2])\/(?:0[1-9]|[12][0-9]|30|31)$/;
export const dateRegex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/;
export const emailRegex =
    /^[a-zA-Z0-9][a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]*(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
export const passwordRules = /^(?=.{12,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z]).*$/;
export const postalCodeCA = /^[A-Za-z]\d[A-Za-z] \d[A-Za-z]\d$/;
export const USMilitaryBase = /\b(?:APO|DPO|FPO)(?:\sAE)?(?!\s+$)\b/;
export const postalCodeUS = /^\d{5}(-\d{4})?$/;
export const noConsequentHyphens = /^(?!.*--).*$/;
//For PO box regex everytime when we switch it we need to notify the BE team to keep it in sync, and other way around.
export const poBox =
    /^(?!\b(?:p[\W_]*o[\W_]*(?:st[\W_]*office[\W_]*)?box|cp|boîte[\W_]*postale)\b).*$/iu;

export const JPFurigana = /^[\u3040-\u309F\u30A0-\u30FF]+$/;
export const postalCodeJP = /^\d{7}$/;
export const fullNameParser = /(\S+)/g;
export const numericString = /^\d+$/;

// VAT number regex
export const vatNumberPL = /^(PL)[0-9]{10}$/;
export const vatNumberPT = /^[0-9]{9}$/;

//Before Headless each market had its own formats for orders. This validators cover these requirements
export const OrderValidationFormat: Record<Market, RegExp> = {
    [Market.MY]: /^(#?MY-\d{11}|MY\d{9}|8700-\d{6}|8700R-d{6})$/,
    [Market.SG]: /^(#?(DE|EC)\d{8}|SG\d{9}|(3800|3800R)-(\d{6}|\d{9}))$/,
    [Market.ES]: /^(#?ES\d{8}|3600-\d{6}|RO-36\d{9})$/,
    [Market.EE]: /^(#?EE-\d{11}|EE\d{8}|SO-760\d{7}|RO-76\d{9})$/,
    [Market.IN]: /^(#?DE\d{8}|EC\d{8}|IN\d{9}|3820-\d{6}|SO-38\d{9})$/,
    [Market.KR]: /^(#?DE\d{8}|EC\d{8}|KR\d{9}|6800-\d{6}|SO-68\d{9}|6800R-\d{6})$/,
    [Market.JP]: /^(#?(DE|EC)\d{8}|JP\d{9}|SO-(\d{9,10})|6100-\d{5}|6100R-\d{7})$/,
    [Market.AU]: /^(#?(DE|EC)\d{8}|AU\d{9}|ST200-\d{6}|ST-\d{9}|200RO-\d{6,7})$/,
    [Market.CA]: /^(#?(DE|EC)\d{8}|CA\d{9}|(S8|R7|R8)\d{8})$/,
    [Market.US]: /^(#?(DE|EC)\d{8}|US\d{9}|(S7|R7)\d{8})$/,
    // Revisit later if these markets enable live chat and contact form for a more exact regex.
    [Market.GB]: /^(#?GB\d{8})$/,
    [Market.PL]: /^(#?PL\d{8})$/,
    [Market.PT]: /^(#?PT\d{8})$/,
    [Market.HU]: /^(#?HU\d{8})$/,
    [Market.HR]: /^(#?HR\d{8})$/,
    [Market.SK]: /^(#?SK\d{8})$/,
    [Market.SI]: /^(#?SI\d{8})$/,
    [Market.FR]: /^(#?FR\d{8})$/,
    [Market.BE]: /^(#?BE\d{8})$/,
    [Market.CZ]: /^(#?CZ\d{8})$/,
    [Market.AT]: /^(#?AT\d{8})$/,
    [Market.CH]: /^(#?CH\d{8})$/,
    [Market.DE]: /^(#?DE\d{8})$/,
    [Market.NL]: /^(#?NL\d{8})$/,
    [Market.DK]: /^(#?DK\d{8})$/,
    [Market.FI]: /^(#?FI\d{8})$/,
    [Market.IE]: /^(#?IE\d{8})$/,
    [Market.LT]: /^(#?LT\d{8})$/,
    [Market.LV]: /^(#?LV\d{8})$/,
    [Market.NO]: /^(#?NO\d{8})$/,
    [Market.SE]: /^(#?SE\d{8})$/,
};

//^0(?:\d-\d{4}-\d{4}       # 10 digits -> 0x-xxxx-xxxx
//  |\d{2}-\d{3}-\d{4}      # 10 digits -> 0xx-xxx-xxxx
//  |\d{2}-\d{4}-\d{3}      # 10 digits -> 0xx-xxxx-xxx
//  |\d{3}-\d{2}-\d{4}      # 10 digits -> 0xxx-xx-xxxx
//  |\d{4}-\d-\d{4}         # 10 digits -> 0xxxx-x-xxxx
//  |\d{9}                  # 10 digits -> 0xxxxxxxxx
//  |\d{2}-\d{4}-\d{4}      # 11 digits -> 0xx-xxxx-xxxx
//  |\d{10}                 # 11 digits -> 0xxxxxxxxxx
//)$
export const JPPhoneNumberWithDashes =
    /^0(?:\d-\d{4}-\d{4}|\d{2}-\d{3}-\d{4}|\d{2}-\d{4}-\d{3}|\d{3}-\d{2}-\d{4}|\d{4}-\d-\d{4}|\d{9}|\d{2}-\d{4}-\d{4}|\d{10})$/;

/**
 * @description Should start with 04 and be 10 digits.
 */
export const AUPhoneNumber = /^04\d{8}$/;

/**
 * @description Should be 10 digits.
 */
export const CAPhoneNumber = /^\d{10}$/;

/**
 * @description Should be 10 digits.
 */
export const USPhoneNumber = /^\d{10}$/;

/**
 * @description Should be 10 digits.
 */
export const INPhoneNumber = /^\d{10}$/;

/**
 * @description Should be 7 or 8 digits.
 */
export const EEPhoneNumber = /^\d{7,8}$/;

/**
 * @description Should be 9 digits.
 */
export const ESPhoneNumber = /^\d{9}$/;

/**
 * @description Should start with 0 and be 11 digits.
 */
export const KRPhoneNumber = /^0\d{10}$/;

/**
 * @description Should start with digits 1 or 3-9 and be 9 or 10 digits.
 */
export const MYPhoneNumber = /^[13-9]\d{8,9}$/;

/**
 * @description Should start with 6, 8, or 9 and be 8 digits.
 */
export const SGPhoneNumber = /^[689]{1}\d{7}$/;

/**
 * @description Should be 7 to 11 digits.
 */
export const HUPhoneNumber = /^\d{7,11}$/;

/**
 * @description Should be 7 to 11 digits.
 */
export const DEPhoneNumber = /^\d{7,11}$/;

/**
 * @description Should be 7 to 11 digits.
 */
export const ATPhoneNumber = /^\d{7,11}$/;

/**
 * @description Should be 7 to 11 digits.
 */
export const NLPhoneNumber = /^\d{7,11}$/;

/**
 * @description Should be 7 to 11 digits.
 */
export const CHPhoneNumber = /^\d{7,11}$/;

/**
 * @description Should be 7 to 11 digits.
 */
export const phoneNumberFormat: Partial<Record<Market, RegExp>> = {
    [Market.AU]: AUPhoneNumber,
    [Market.CA]: CAPhoneNumber,
    [Market.US]: USPhoneNumber,
    [Market.IN]: INPhoneNumber,
    [Market.EE]: EEPhoneNumber,
    [Market.ES]: ESPhoneNumber,
    [Market.KR]: KRPhoneNumber,
    [Market.MY]: MYPhoneNumber,
    [Market.SG]: SGPhoneNumber,
    [Market.JP]: JPPhoneNumberWithDashes,
    [Market.HU]: HUPhoneNumber,
    [Market.DE]: DEPhoneNumber,
    [Market.AT]: ATPhoneNumber,
    [Market.NL]: NLPhoneNumber,
    [Market.CH]: CHPhoneNumber,
};
